import React, { useState } from 'react';
import { API } from '../../constant';
import { Link } from 'react-router-dom';
import Loading from "../Hooks/Loading";
import QuickCopeImage from "../../Media/QuickCopeImage.svg";
import logo2 from "../../Media/LogoReverseWithTag.svg";

const ResetPassword = () => {

    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [passwordSet, setpasswordSet] = useState('');
    const [loading, setLoading] = useState(false);
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');

const handleResetPassword = async (e) => {
    e.preventDefault();
   
    try {
        setLoading(true);
        const response = await fetch(`${API}/email/reset-password`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token, password }),
        });

        const data = await response.json();
        console.log('Reset password response:', data);

        if (data?.error) {
            console.error('Backend error:', data.error);
            setpasswordSet(data);
            setMessage(data.error.message || 'Token expired or invalid');
        } else {
            setpasswordSet(data);
            setMessage(data.message);
        }
        setLoading(false);

    } catch (error) {
        console.error('Error:', error);
        setMessage('Error resetting password');
        setLoading(false);
    }
};
const showPassword = (e)=>{
    let inputval = e.target.previousSibling.getAttribute("type");
    if(inputval == "password"){
        e.target.previousSibling.setAttribute("type", "text");
        e.target.classList.remove("hide");
    }else{
        e.target.previousSibling.setAttribute("type", "password");
        e.target.classList.add("hide");
    }
        
}
const content = ()=>{
    if(message){
        return <div className="success-message btn btn-gradient btn-full btn-white mb---10 btn-center delay-2">
                    <div className="success fade-in-down delay-1 notice">Your password reset successfully</div>
                    <Link to="/Login" className='mt---20'>Login</Link>
                </div>
    }else if(passwordSet.error){
        return <div className="error-message fade-in-down delay-1">{passwordSet.error.message}</div>
    }else{
        return <form onSubmit={handleResetPassword}>
                    <label className="input-field password fade-in-down delay-3">
                        <input className="" type="password" value={password} name='resetPassword' placeholder="Enter new password" onChange={(e) => setPassword(e.target.value)} required/>
                        <span onClick={showPassword} className="eye-icon hide"></span>
                    </label>
                    <button className="theme-btn gradient-btn fade-in-down delay-4" type="submit">Reset Password</button>
                    
                </form>
    }
}
return(
    <div className="forget-reset-password">
        {loading && <Loading />}

        <div className="container">
            <div className="content-wrap bg-blue">
                <div className="quick-cope">
                    <div className="theme-form">
                        <img className="fade-in-down delay-1" src={logo2} alt="logo-img"/>
                        <h2 className="mt---30 fade-in-down delay-2">Reset Password?</h2>
                        {content()}
                    </div>
                </div>
            </div>  
        </div>
    </div>
);
};

export default ResetPassword;